module.exports = __webpack_public_path__ + "img/que_ans.03142ea2.jpg";